import { render, staticRenderFns } from "./VendorField.vue?vue&type=template&id=e252b81c"
import script from "./VendorField.vue?vue&type=script&lang=js"
export * from "./VendorField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports